import React, { useEffect, useState } from 'react';
import DynamicServices from '../../services/externalServices/TicketServices/dynamicServices';
// import { FiSearch, FiX, FiArrowUp, FiArrowDown, FiFilter } from 'react-icons/fi';
import {
    FiSearch, FiX, FiHome, FiFilm, FiCalendar, FiFilter,
    FiClock, FiGrid, FiDollarSign, FiList, FiChevronDown, FiArrowDown, FiArrowUp, FiEdit2, FiTrash2
} from 'react-icons/fi';

//   import { FiEdit2, FiTrash2, FiX } from 'react-icons/fi';
const DynamicReport = () => {
    const [reportData, setReportData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [filters, setFilters] = useState({
        theatre: '',
        movie: '',
        date: '',
        time: '',
        section: '',
        price: '',
        sequence: ''
    });

    const [editModalOpen, setEditModalOpen] = useState(false);
    const [currentEditItem, setCurrentEditItem] = useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');


    useEffect(() => {
        fetchPricingData();
    }, []);

    const fetchPricingData = async () => {
        try {
            const theatreId = accessList?.[0];  // Only allowing one for now
console.log('theatreId',theatreId);

            const res = await DynamicServices.getAllPricingDetails(theatreId);
            if (res.success) {
                setReportData(res.data);
                console.log('res in the dynamic service', res.data)
            }
        } catch (err) {
            console.error('Error fetching report:', err);
        }
    };


    // Sorting function
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };



    // Update filter
    const handleFilterChange = (filterName, value) => {
        setFilters(prev => ({
            ...prev,
            [filterName]: value
        }));
    };

    // Clear all filters
    const clearFilters = () => {
        setSearchQuery('');
        setFilters({
            theatre: '',
            movie: '',
            date: '',
            time: '',
            section: '',
            price: '',
            sequence: ''
        });
        setSortConfig({ key: null, direction: 'asc' });
    };



    // In your groupedData calculation:
    const groupedData = reportData?.map(entry => ({
        _id: entry?._id,
        theatreName: entry?.theatreName,
        movieTitle: entry?.movieTitle,
        date: entry?.date,
        times: entry?.time?.join(', '),
        seatLayout: entry?.seatLayout || [],
        validityFrom: entry?.validityFrom,
        validityUntil: entry?.validityUntil
    })) || []


    // Sorting function (adjusted for grouped data)
    const sortedData = [...groupedData]?.sort((a, b) => {
        if (sortConfig.key) {
            if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
        }
        return 0;
    });

    // Apply filters (adjusted for grouped data)
    const filteredData = sortedData.filter((item) => {
        // console.log('item in the dynamic reports=====', item);
        console.log('item.times type ===', typeof item.times, item.times);
        console.log('filters.time ===', filters.time);
        console.log('item.times type ===', item.times);
        console.log('item.times type ===', filters.theatre);
        console.log('item.times type ===', filters.movie);
        console.log('item.times type ===', filters.date);
        console.log('item.times type ===', item.date);


        return (
            (filters.theatre === '' || item.theatreName === filters.theatre) &&
            (filters.movie === '' || item.movieTitle === filters.movie) &&
            (filters.date === '' || item.date === filters.date) &&
            (filters.time === '' || item.times === filters.time) &&
            (
                item.theatreName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.movieTitle.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.date.includes(searchQuery) ||
                item.times.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    });

    // In your flattenedData calculation:
    const flattenedData = reportData?.flatMap((entry) =>
        entry?.seatLayout?.map((seat) => ({
            theatreName: entry?.theatreName,
            movieTitle: entry?.movieTitle,
            date: entry?.date,
            time: entry?.time?.join(', '),
            section: seat?.Name,
            price: seat?.Price,
            sequence: seat?.Sequence,
            _id: seat?._id,
            parentId: entry?._id,
            originalEntry: entry
        })) || []
    )


    // In your uniqueValues calculation:
    // const uniqueValues = {
    //     theatre: [...new Set(groupedData?.map(item => item?.theatreName).filter(Boolean))].sort(),
    //     movie: [...new Set(groupedData?.map(item => item?.movieTitle).filter(Boolean))].sort(),
    //     date: [...new Set(groupedData?.map(item => item?.date).filter(Boolean))].sort(),
    //     time: [...new Set(groupedData?.map(item => item?.times).filter(Boolean))].sort()
    // }

    const uniqueValues = {
        theatre: [...new Set(groupedData?.map(item => item?.theatreName).filter(Boolean))].sort(),
        movie: [...new Set(groupedData?.map(item => item?.movieTitle).filter(Boolean))].sort(),
        date: [...new Set(groupedData?.map(item => item?.date).filter(Boolean))].sort(),
        time: [...new Set(groupedData?.map(item => item?.times).filter(Boolean))].sort(),
        section: [...new Set(flattenedData?.map(item => item?.section).filter(Boolean))].sort(),
        price: [...new Set(flattenedData?.map(item => item?.price).filter(Boolean))].sort(),
        sequence: [...new Set(flattenedData?.map(item => item?.sequence).filter(Boolean))].sort()
    };


    // In your renderSeatSections function:
    // const renderSeatSections = (sections) => {
    //     if (!sections || !sections.length) return <span className="text-gray-400">No sections</span>;

    //     return (
    //         <div className="flex flex-wrap gap-2">
    //             {sections.map((section, index) => (
    //                 <div key={index} className="bg-gray-50 px-3 py-1 rounded-md text-sm">
    //                     <span className="font-medium">{section?.Name}</span>:
    //                     <span className="text-blue-600 ml-1">₹{section?.Price}</span>
    //                     {/* <span className="text-gray-500 ml-2">(Seq: {section?.Sequence})</span> */}
    //                 </div>
    //             ))}
    //         </div>
    //     );
    // };



    const renderSeatSections = (sections) => {
        if (!sections || !sections.length) return <span className="text-gray-400">No sections</span>;

        return (
            <div className="flex flex-wrap gap-2">
                {sections.map((section, index) => (
                    <div key={index} className="bg-gray-50 px-3 py-1 rounded-md text-sm">
                        <span className="font-medium">{section?.Name}</span>:
                        <span className="text-blue-600 ml-1">₹{section?.Price}</span>
                        {section?.ConvenienceFee != null && section?.ConvenienceFee > 0 && (
                            <span className="text-gray-500 ml-2">(CF ₹{section.ConvenienceFee})</span>
                        )}
                    </div>
                ))}
            </div>
        );
    };


    // Action column for the table
    const actionColumn = {
        key: 'actions',
        label: 'Actions',
        render: (item) => (
            <div className="flex space-x-2">
                <button
                    onClick={() => handleEdit(item)}
                    className="p-1 text-blue-600 hover:text-blue-800"
                    title="Edit"
                >
                    <FiEdit2 size={16} />
                </button>
                {/* <button
                    onClick={() => handleDelete(item)}
                    className="p-1 text-red-600 hover:text-red-800"
                    title="Delete"
                >
                    <FiTrash2 size={16} />
                </button> */}
            </div>
        )
    };

    // Modified edit handler
    const handleEdit = (item) => {
        console.log('item', item);

        setCurrentEditItem(item);
        setEditModalOpen(true);
    };

    // Modified delete handler
    const handleDelete = (item) => {
        setItemToDelete(item);
        setDeleteConfirmOpen(true);
    };

    // Confirm delete (now deletes entire configuration)
    const confirmDelete = async () => {
        try {
            const response = await DynamicServices.deleteDynamicPrice({
                id: itemToDelete._id // Now deleting the entire configuration
            });

            if (response.success) {
                alert('Pricing configuration deleted successfully');
                fetchPricingData(); // Refresh data
            } else {
                alert('Error deleting pricing: ' + response.message);
            }
        } catch (err) {
            console.error('Error deleting pricing:', err);
            alert('Error deleting pricing');
        } finally {
            setDeleteConfirmOpen(false);
            setItemToDelete(null);
        }
    };

    // Save edited item (now updates entire configuration)
    // const saveEditedItem = async (updatedData) => {

    //     console.log('currentEditItem====', currentEditItem)
    //     try {
    //         const response = await DynamicServices.updateDynamicPrice({
    //             id: currentEditItem._id,
    //             updates: updatedData
    //         });

    //         console.warn('response of the edit', response);

    //         if (response.success) {
    //             alert('Pricing updated successfully');
    //             fetchPricingData(); // Refresh data
    //             setEditModalOpen(false);
    //         } else {
    //             alert('Error updating pricing: ' + response.message);
    //         }
    //     } catch (err) {
    //         console.error('Error updating pricing:', err);
    //         alert('Error updating pricing');
    //     }
    // };


    const saveEditedItem = async (updatedData) => {
        try {
            const response = await DynamicServices.updateDynamicPrice({
                id: currentEditItem._id,
                updates: updatedData
            });
    
            console.warn('response of the edit', response);
    
            if (response.message === "Dynamic Pricing Updated") {
                let alertMessage = 'Pricing updated successfully';
                if (Array.isArray(response.warnings) && response.warnings.length > 0) {
                    alertMessage += `\n\nWarnings:\n${response.warnings.join('\n')}`;
                }
    
                alert(alertMessage);
                fetchPricingData(); // Refresh data
                setEditModalOpen(false);
            } else {
                alert('Unexpected response: ' + (response.message || 'No message from server'));
            }
        } catch (err) {
            console.error('Error updating pricing:', err);
            alert('Error updating pricing');
        }
    };
    

    return (
        <div className="min-h-screen bg-gray-50 p-6">
            <div className="max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="mb-8 flex items-center justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">Dynamic Pricing Analytics</h1>
                        <p className="mt-2 text-gray-500">Real-time ticket pricing across all venues</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                            {flattenedData.length} records
                        </span>
                    </div>
                </div>

                {/* Search and Filters Section */}
                <div className="bg-white rounded-xl shadow-sm p-6 mb-6 border border-gray-100">
                    <div className="flex items-center gap-4 mb-6">
                        <div className="flex-1 relative">
                            <FiSearch className="absolute left-4 top-3.5 text-gray-400" />
                            <input
                                type="text"
                                placeholder="Search across all fields..."
                                className="w-full pl-11 pr-4 py-3 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            {searchQuery && (
                                <button
                                    onClick={() => setSearchQuery('')}
                                    className="absolute right-4 top-3.5 text-gray-400 hover:text-gray-600"
                                >
                                    <FiX size={18} />
                                </button>
                            )}
                        </div>
                        <button
                            onClick={clearFilters}
                            className="flex items-center gap-2 px-4 py-3 bg-blue-50 text-blue-700 hover:bg-blue-100 rounded-lg transition-colors"
                        >
                            <FiFilter size={18} />
                            Clear Filters
                        </button>
                    </div>

                    {/* Filter Chips */}
                    <div className="flex flex-wrap gap-2">
                        {Object.entries(filters).map(([key, value]) => (
                            value && (
                                <div
                                    key={key}
                                    className="flex items-center bg-gray-50 px-3 py-1.5 rounded-full text-sm"
                                >
                                    <span className="capitalize mr-1 text-gray-600">{key}:</span>
                                    <span className="font-medium text-gray-800">{value}</span>
                                    <button
                                        onClick={() => handleFilterChange(key, '')}
                                        className="ml-2 text-gray-400 hover:text-gray-600"
                                    >
                                        <FiX size={14} />
                                    </button>
                                </div>
                            )
                        ))}
                    </div>
                </div>

                {/* new code */}
                {/* Search and Filters Section */}
                <div className="bg-white rounded-xl p-6 mb-6 shadow-sm border border-gray-100">
                    {/* Unified Search */}
                    <div className="relative mb-6">
                        <FiSearch className="absolute left-4 top-3.5 text-gray-400 text-lg" />
                        <input
                            type="text"
                            placeholder="Search theatres, movies, sections..."
                            className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        {searchQuery && (
                            <button
                                onClick={() => setSearchQuery('')}
                                className="absolute right-4 top-3.5 text-gray-400 hover:text-gray-600"
                            >
                                <FiX size={20} />
                            </button>
                        )}
                    </div>

                    {/* Advanced Filters Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-3">
                        {[
                            {
                                id: 'theatre',
                                label: 'Theatre',
                                options: uniqueValues.theatre,
                                icon: <FiHome className="text-gray-400" />
                            },
                            {
                                id: 'movie',
                                label: 'Movie',
                                options: uniqueValues.movie,
                                icon: <FiFilm className="text-gray-400" />
                            },
                            {
                                id: 'date',
                                label: 'Date',
                                options: uniqueValues.date,
                                icon: <FiCalendar className="text-gray-400" />,
                                format: (date) => new Date(date).toLocaleDateString('en-GB')
                            },
                            {
                                id: 'time',
                                label: 'Time',
                                options: uniqueValues.time,
                                icon: <FiClock className="text-gray-400" />
                            },
                            {
                                id: 'section',
                                label: 'Section',
                                options: uniqueValues.section,
                                icon: <FiGrid className="text-gray-400" />
                            },
                            {
                                id: 'price',
                                label: 'Price',
                                options: uniqueValues.price,
                                icon: <FiDollarSign className="text-gray-400" />,
                                format: (price) => `₹${price}`
                            },
                            {
                                id: 'sequence',
                                label: 'Sequence',
                                options: uniqueValues.sequence,
                                icon: <FiList className="text-gray-400" />
                            }
                        ].map((filter) => (
                            <div key={filter.id} className="relative group">
                                <label className="block text-sm font-medium text-gray-700 mb-1.5 ml-1">
                                    {filter.label}
                                </label>
                                <div className="relative">
                                    <div className="absolute left-3 top-2.5 z-10">
                                        {filter.icon}
                                    </div>
                                    <select
                                        className="w-full pl-10 pr-4 py-2.5 appearance-none bg-white rounded-lg border border-gray-200 hover:border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all cursor-pointer"
                                        value={filters[filter.id]}
                                        onChange={(e) => handleFilterChange(filter.id, e.target.value)}
                                    >
                                        <option value="">All</option>
                                        {filter.options.map((value) => (
                                            <option
                                                key={value}
                                                value={value}
                                                className="flex items-center gap-2"
                                            >
                                                {filter.format ? filter.format(value) : value}
                                            </option>
                                        ))}
                                    </select>
                                    <FiChevronDown className="absolute right-3 top-3 text-gray-400 pointer-events-none" />
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Active Filters Chips */}
                    <div className="mt-4 flex flex-wrap gap-2">
                        {Object.entries(filters).map(([key, value]) =>
                            value ? (
                                <div
                                    key={key}
                                    className="flex items-center bg-blue-50 px-3 py-1.5 rounded-full text-sm"
                                >
                                    <span className="capitalize mr-1 text-blue-700">
                                        {key}:
                                    </span>
                                    <span className="font-medium text-blue-800">
                                        {key === 'date' ? new Date(value).toLocaleDateString('en-GB') : value}
                                    </span>
                                    <button
                                        onClick={() => handleFilterChange(key, '')}
                                        className="ml-2 text-blue-500 hover:text-blue-700"
                                    >
                                        <FiX size={14} />
                                    </button>
                                </div>
                            ) : null
                        )}
                    </div>
                </div>
                {/* end */}

                {/* Data Table Section */}


                <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50 border-b border-gray-200">
                                <tr>
                                    {Object.entries({
                                        date: 'Date',
                                        theatreName: 'Theatre',
                                        movieTitle: 'Movie',
                                        times: 'Show Times',
                                        seatLayout: 'Seat Sections',
                                        actions: 'Actions'
                                    }).map(([key, label]) => (
                                        <th
                                            key={key}
                                            className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors"
                                            onClick={() => key !== 'actions' && key !== 'seatLayout' && requestSort(key)}
                                        >
                                            <div className="flex items-center gap-1">
                                                {label}
                                                {sortConfig.key === key && (
                                                    <span className="text-blue-600">
                                                        {sortConfig.direction === 'asc' ? <FiArrowUp /> : <FiArrowDown />}
                                                    </span>
                                                )}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {filteredData.map((item) => (
                                    <tr key={item._id} className="hover:bg-gray-50 transition-colors group">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                            {new Date(item.date).toLocaleDateString('en-GB')}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                            {item.theatreName}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                            {item.movieTitle}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                            <span className="inline-block px-2 py-1 bg-green-50 text-green-700 rounded-md">
                                                {item.times}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-600">
                                            {renderSeatSections(item.seatLayout)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            {actionColumn.render(item)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>





                {/* Edit Modal */}

                {/* Edit Modal - Updated for full configuration editing */}
                {editModalOpen && currentEditItem && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                        <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl">
                            <div className="p-6">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="text-lg font-semibold">Edit Pricing Configuration</h3>
                                    <button onClick={() => setEditModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                                        <FiX size={20} />
                                    </button>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    
                                    <div>
                                        <h4 className="font-medium mb-3">Basic Information</h4>
                                        <div className="space-y-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Theatre</label>
                                                <div className="p-2 bg-gray-50 rounded-md">
                                                    {currentEditItem.theatreName}
                                                </div>
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Movie</label>
                                                <div className="p-2 bg-gray-50 rounded-md">
                                                    {currentEditItem.movieTitle}
                                                </div>
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
                                                {currentEditItem.date}
                                                {/* <input
                                                    type="date"
                                                    value={currentEditItem.date}
                                                    onChange={(e) => setCurrentEditItem({
                                                        ...currentEditItem,
                                                        date: e.target.value
                                                    })}
                                                    className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                /> */}
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Show Times</label>
                                                {currentEditItem.times}
                                                {/* <input
                                                    type="text"
                                                    value={currentEditItem.times}
                                                    onChange={(e) => setCurrentEditItem({
                                                        ...currentEditItem,
                                                        times: e.target.value
                                                    })}
                                                    className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                    placeholder="e.g. 10:00 AM, 1:00 PM, 4:00 PM"
                                                /> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <h4 className="font-medium mb-3">Seat Pricing</h4>
                                        <div className="space-y-4 max-h-64 overflow-y-auto pr-2">
                                            {currentEditItem.seatLayout.map((section, index) => (
                                                <div key={index} className="bg-gray-50 p-3 rounded-md">
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-500 mb-1">Section</label>
                                                            <input
                                                                type="text"
                                                                value={section.Name}
                                                                disabled // ✅ disables editing
                                                                onChange={(e) => {
                                                                    const updatedLayout = [...currentEditItem.seatLayout];
                                                                    updatedLayout[index].Name = e.target.value;
                                                                    setCurrentEditItem({
                                                                        ...currentEditItem,
                                                                        seatLayout: updatedLayout
                                                                    });
                                                                }}
                                                                className="w-full px-2 py-1 text-sm rounded border border-gray-300"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-500 mb-1">Price</label>
                                                            <input
                                                                type="number"
                                                                value={section.Price}
                                                                onChange={(e) => {
                                                                    const updatedLayout = [...currentEditItem.seatLayout];
                                                                    updatedLayout[index].Price = e.target.value;
                                                                    setCurrentEditItem({
                                                                        ...currentEditItem,
                                                                        seatLayout: updatedLayout
                                                                    });
                                                                }}
                                                                className="w-full px-2 py-1 text-sm rounded border border-gray-300"
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-500 mb-1">Convenience Fee</label>
                                                            <input
                                                                type="number"
                                                                value={section.ConvenienceFee || 0}
                                                                onChange={(e) => {
                                                                    const updatedLayout = [...currentEditItem.seatLayout];
                                                                    updatedLayout[index].ConvenienceFee = Number(e.target.value);
                                                                    setCurrentEditItem({
                                                                        ...currentEditItem,
                                                                        seatLayout: updatedLayout
                                                                    });
                                                                }}
                                                                className="w-full px-2 py-1 text-sm rounded border border-gray-300"
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-500 mb-1">Sequence</label>
                                                            <input
                                                                type="number"
                                                                value={section.Sequence}
                                                                disabled // ✅ disables editing
                                                                onChange={(e) => {
                                                                    const updatedLayout = [...currentEditItem.seatLayout];
                                                                    updatedLayout[index].Sequence = e.target.value;
                                                                    setCurrentEditItem({
                                                                        ...currentEditItem,
                                                                        seatLayout: updatedLayout
                                                                    });
                                                                }}
                                                                className="w-full px-2 py-1 text-sm rounded border border-gray-300"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>







    


                                    
                                </div>

                                <div className="mt-6 flex justify-end space-x-3">
                                    <button
                                        onClick={() => setEditModalOpen(false)}
                                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={() => saveEditedItem({
                                            date: currentEditItem.date,
                                            times: currentEditItem.times,
                                            seatLayout: currentEditItem.seatLayout
                                        })}
                                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Delete Confirmation Modal */}
                {deleteConfirmOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                        <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
                            <div className="p-6">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="text-lg font-semibold">Confirm Deletion</h3>
                                    <button onClick={() => setDeleteConfirmOpen(false)} className="text-gray-500 hover:text-gray-700">
                                        <FiX size={20} />
                                    </button>
                                </div>

                                <p className="mb-6">Are you sure you want to delete this pricing configuration?</p>

                                <div className="flex justify-end space-x-3">
                                    <button
                                        onClick={() => setDeleteConfirmOpen(false)}
                                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={confirmDelete}
                                        className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}




            </div>
        </div>
    );
};











export default DynamicReport;